import React, { Component, Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { func } from "prop-types";

import { asyncValidate, shouldAsyncValidate } from "redux-form-yup";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import * as Mask from "../../../../services/utils/mask";
import * as Yup from "yup";

import { Form, Button, FloatLabelInput } from "shared/components";
import Loader from "../../../../components/Loading";
import { createCommonIncident } from "../../../../services/state/actions";
import styles from "../../styles.css";
import InputCheckbox from "../../../InputCheckbox";
import _pickBy from "lodash/pickBy";
import _pick from "lodash/pick";
import _isBoolean from "lodash/isBoolean";
import _keys from "lodash/keys";
import _omit from "lodash/omit";
import { INCIDENT_VOICE_DESCRIPTION } from "services/state/repair/constants";

class LowQualityForm extends Component {
  onSubmit = (form) => {
    const { t, reason, createCommonIncident, onNextStep, onReset } = this.props;
    const problem = _pickBy(
      _pick(form, ["eco", "ruido", "picote"]),
      _isBoolean
    );
    const keys = _keys(problem);
    const filtered = keys.filter(function (key) {
      return problem[key];
    });

    form.description = filtered.join(", ").replace(/,(?!.*,)/gi, " e");
    const newForm = _omit(form, ["eco", "ruido", "picote"]);

    const checklist = {
      data: { ...newForm, reason },
      labels: {
        keyLowQuality: t("MSG_0281"),
        contactPhone: t("MSG_0206"),
        timeSlot: t("MSG_0205"),
        description: t("MSG_0398"),
        evidences: t("MSG_0284"),
      },
    };

    return createCommonIncident(checklist, onNextStep, onReset);
  };

  renderDescriptionOptions() {
    return (
      <div className={styles.radioRoot}>
        <p className={styles.titleRadio}>{this.props.t("MSG_0202")}</p>
        <div>
          {INCIDENT_VOICE_DESCRIPTION.map((item) => (
            <Field
              key={item.id}
              id={item.id}
              name={item.id}
              component={(field) => (
                <InputCheckbox
                  id={item.id}
                  label={item.label}
                  inputProps={field.input}
                />
              )}
              type="checkbox"
            />
          ))}
        </div>
      </div>
    );
  }

  // TODO: Refatorar, métodos utilizados em formulários
  renderInputField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;

    return (
      <FloatLabelInput
        {...field.input}
        id={field.id}
        type={field.type}
        label={field.label}
        maxLength={field.maxLength}
        invalid={touched && invalid}
        error={error}
      />
    );
  }

  render() {
    const { t, handleSubmit, submitting, onPreviousStep } = this.props;

    return (
      <Fragment>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <span className={styles.title}>{t("MSG_0211")}</span>
          <Field
            id="keyLowQuality"
            label={t("MSG_0281")}
            name="keyLowQuality"
            component={this.renderInputField}
            format={Mask.phone}
            normalize={Mask.algarPhone}
          />

          {this.renderDescriptionOptions()}

          <Field
            id="evidences"
            name="evidences"
            label={t("MSG_0284")}
            component={this.renderInputField}
          />

          <Field
            id="timeSlot"
            label={t("MSG_0205")}
            name="timeSlot"
            component={this.renderInputField}
            format={Mask.timeRange}
            normalize={Mask.timeRange}
          />

          <Field
            id="contactPhone"
            label={t("MSG_0206")}
            name="contactPhone"
            component={this.renderInputField}
            format={Mask.phone}
            maxLength="15"
            normalize={Mask.algarPhone}
          />

          <div className={styles.actions}>
            <Button onClick={onPreviousStep} relevance="low">
              {t("MSG_0292")}
            </Button>

            <Button
              relevance="normal"
              callToAction
              type="submit"
              disabled={submitting}
            >
              {t("MSG_0007")}
            </Button>
          </div>
        </Form>

        <Loader isOpen={submitting} />
      </Fragment>
    );
  }
}

function createValidationSchema() {
  return Yup.object().shape({
    keyLowQuality: Yup.string().required("Campo obrigatório"),

    evidences: Yup.string().required("Campo obrigatório"),

    timeSlot: Yup.string().required("Campo obrigatório"),

    contactPhone: Yup.string()
      .required("Campo obrigatório")
      .matches(/^0\d{1,14}$/, {
        message: "Número de telefone inválido",
        excludeEmptyString: true,
      }),
  });
}

LowQualityForm.propTypes = {
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
};

const reduxFormConfig = {
  form: "LowQualityForm",
  asyncValidate: asyncValidate(createValidationSchema()),
  shouldAsyncValidate,
};

const enhance = compose(
  translate(),
  connect(null, { createCommonIncident }),
  reduxForm(reduxFormConfig)
);

export default enhance(LowQualityForm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalTotalVoice/LowQualityForm.js